import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { makeStyles } from "@mui/styles";
import { DatePicker } from "@mui/x-date-pickers";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiInputBase-root": {
      "& .MuiIconButton-root": {
        padding: 4,
        "& svg": {
          fontSize: 20,
        },
      },
      "& .MuiInputBase-input": {
        color: "#66615b",
        fontSize: 12,
        height: "100%",
        padding: 10,
        paddingRight: 0,
      },
    },
  },
}));

const DateFullEx = ({
  label,
  value,
  onChange,
  ...props
}) => {
  const classes = useStyles();
  const intl = useIntl();

  return (
    <DatePicker
      className={classes.root}
      label={label}
      localeText={{
        clearButtonLabel: intl.formatMessage({ id: "common.clear" }),
      }}
      onChange={onChange}
      slotProps={{
        actionBar: {
          actions: ["clear"],
        },
        popper: {
          onKeyDown: props.onKeyDown,
          onKeyUp: props.onKeyUp,
        },
        textField: {
          onKeyDown: props.onKeyDown,
          onKeyUp: props.onKeyUp,
        },
      }}
      sx={{ width: "100%" }}
      {...props}
      value={value}
    />
  );
};

DateFullEx.propTypes = {
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.string]).isRequired,
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
};

DateFullEx.defaultProps = {
  value: null,
};

export default DateFullEx;
